var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorderImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 135,
    viewBox: "0 0 114 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4,
    r: 1,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4,
    r: 1,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 4,
    r: 1,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 4,
    r: 1,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 4,
    r: 1,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 4,
    r: 1,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 4,
    r: 1,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 2.5,
    x2: 11,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 2.5,
    x2: 25,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 2.5,
    x2: 39,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 2.5,
    x2: 53,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 2.5,
    x2: 67,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 2.5,
    x2: 81,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 2.5,
    x2: 95,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 2.5,
    x2: 109,
    y2: 2.5,
    stroke: "black",
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.990909,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8637,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.7363,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.6091,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4819,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.3544,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2272,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.1,
    cy: 134,
    rx: 0.990909,
    ry: 1,
    fill: "black"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 3.96362,
    y1: 132.5,
    x2: 11.8909,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 17.8364,
    y1: 132.5,
    x2: 25.7637,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 31.709,
    y1: 132.5,
    x2: 39.6363,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5818,
    y1: 132.5,
    x2: 53.5091,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 59.4546,
    y1: 132.5,
    x2: 67.3819,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 73.3271,
    y1: 132.5,
    x2: 81.2544,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 87.2,
    y1: 132.5,
    x2: 95.1272,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 101.073,
    y1: 132.5,
    x2: 109,
    y2: 132.5,
    stroke: "black",
    strokeWidth: 5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 5.016,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 5.016)",
    fill: "black"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 19.2406,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 19.2406)",
    fill: "black"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 33.4633,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 33.4633)",
    fill: "black"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 47.6879,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 47.6879)",
    fill: "black"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 61.9125,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 61.9125)",
    fill: "black"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 76.1351,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 76.1351)",
    fill: "black"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 90.3597,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 90.3597)",
    fill: "black"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 104.584,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 104.584)",
    fill: "black"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 119.825,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 1 119.825)",
    fill: "black"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 8.06445,
    x2: 2.5,
    y2: 16.1925,
    stroke: "black",
    strokeWidth: 5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 22.2871,
    x2: 2.5,
    y2: 30.4151,
    stroke: "black",
    strokeWidth: 5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 36.5117,
    x2: 2.5,
    y2: 44.6397,
    stroke: "black",
    strokeWidth: 5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 50.7363,
    x2: 2.5,
    y2: 58.8643,
    stroke: "black",
    strokeWidth: 5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 64.9609,
    x2: 2.5,
    y2: 73.0889,
    stroke: "black",
    strokeWidth: 5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 79.1836,
    x2: 2.5,
    y2: 87.3116,
    stroke: "black",
    strokeWidth: 5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 93.4082,
    x2: 2.5,
    y2: 101.536,
    stroke: "black",
    strokeWidth: 5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 107.633,
    x2: 2.5,
    y2: 115.761,
    stroke: "black",
    strokeWidth: 5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 122.871,
    x2: 2.5,
    y2: 130.999,
    stroke: "black",
    strokeWidth: 5
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 6.016,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 6.016)",
    fill: "black"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 20.2406,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 20.2406)",
    fill: "black"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 34.4633,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 34.4633)",
    fill: "black"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 48.6879,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 48.6879)",
    fill: "black"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 62.9125,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 62.9125)",
    fill: "black"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 77.1351,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 77.1351)",
    fill: "black"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 91.3597,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 91.3597)",
    fill: "black"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 105.584,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 105.584)",
    fill: "black"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 120.825,
    rx: 1.016,
    ry: 1,
    transform: "rotate(90 110 120.825)",
    fill: "black"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 9.06445,
    x2: 111.5,
    y2: 17.1925,
    stroke: "black",
    strokeWidth: 5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 23.2871,
    x2: 111.5,
    y2: 31.4151,
    stroke: "black",
    strokeWidth: 5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 37.5117,
    x2: 111.5,
    y2: 45.6397,
    stroke: "black",
    strokeWidth: 5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 51.7363,
    x2: 111.5,
    y2: 59.8643,
    stroke: "black",
    strokeWidth: 5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 65.9609,
    x2: 111.5,
    y2: 74.0889,
    stroke: "black",
    strokeWidth: 5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 80.1836,
    x2: 111.5,
    y2: 88.3116,
    stroke: "black",
    strokeWidth: 5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 94.4082,
    x2: 111.5,
    y2: 102.536,
    stroke: "black",
    strokeWidth: 5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 108.633,
    x2: 111.5,
    y2: 116.761,
    stroke: "black",
    strokeWidth: 5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 123.871,
    x2: 111.5,
    y2: 131.999,
    stroke: "black",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0202 83.3547V78.6698L59.6888 45.9675H63.0876V53.2245H60.7911L45.1748 77.9349V78.3023H73.0085V83.3547H39.0202ZM61.1585 93V81.9308V79.7491V45.9675H66.5783V93H61.1585Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderImage2);
export default __webpack_public_path__ + "static/media/borderImage2.b944e498af507b6662f6da3c74fab486.svg";
export { ForwardRef as ReactComponent };